export enum ObjectTypesEnum {
    Report = 1,
    Dashboard = 2,
    Drilldown = 3,
}
